/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function StreemApiSmsDeliveryStatusFromJSON(json) {
    return StreemApiSmsDeliveryStatusFromJSONTyped(json, false);
}
export function StreemApiSmsDeliveryStatusFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'smsDeliveryStatusSid': !exists(json, 'sms_delivery_status_sid') ? undefined : json['sms_delivery_status_sid'],
        'messageId': !exists(json, 'message_id') ? undefined : json['message_id'],
        'deliveryStatus': !exists(json, 'delivery_status') ? undefined : json['delivery_status'],
        'invitationSid': !exists(json, 'invitation_sid') ? undefined : json['invitation_sid'],
        'errorCode': !exists(json, 'error_code') ? undefined : json['error_code'],
        'smsPlatform': !exists(json, 'sms_platform') ? undefined : json['sms_platform'],
    };
}
export function StreemApiSmsDeliveryStatusToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'sms_delivery_status_sid': value.smsDeliveryStatusSid,
        'message_id': value.messageId,
        'delivery_status': value.deliveryStatus,
        'invitation_sid': value.invitationSid,
        'error_code': value.errorCode,
        'sms_platform': value.smsPlatform,
    };
}
/**
* @export
* @enum {string}
*/
export var StreemApiSmsDeliveryStatusSmsPlatform;
(function (StreemApiSmsDeliveryStatusSmsPlatform) {
    StreemApiSmsDeliveryStatusSmsPlatform["TELNYX"] = "SMS_PLATFORM_TELNYX";
    StreemApiSmsDeliveryStatusSmsPlatform["TWILIO"] = "SMS_PLATFORM_TWILIO";
    StreemApiSmsDeliveryStatusSmsPlatform["INVALID"] = "SMS_PLATFORM_INVALID";
})(StreemApiSmsDeliveryStatusSmsPlatform || (StreemApiSmsDeliveryStatusSmsPlatform = {}));
//# sourceMappingURL=StreemApiSmsDeliveryStatus.js.map